class Accordion {
  #i;
  constructor(i) {
    (this.#i = window.matchMedia('(prefers-reduced-motion: reduce)')),
      (this.el = i),
      (this.summary = i.querySelector('summary')),
      (this.content = i.querySelector('details-content')),
      (this.animation = null),
      (this.isClosing = !1),
      (this.isExpanding = !1),
      this.summary.addEventListener('click', (i) => this.onClick(i));
  }
  onClick(i) {
    i.preventDefault(),
      this.el.hasAttribute('non-dismissible') ||
        (this.isClosing || !this.el.open
          ? this.open()
          : (this.isExpanding || this.el.open) && this.shrink());
  }
  shrink() {
    this.el.dispatchEvent(new CustomEvent('on:accordion:closing')),
      (this.isClosing = !0),
      this.el.classList.add('is-closing'),
      (this.el.style.overflow = 'hidden');
    const i = `${this.el.offsetHeight + 40}px`,
      e = `${this.summary.offsetHeight + 40}px`;
    this.animation &&
      (this.animation.cancel(),
      this.el.dispatchEvent(new CustomEvent('on:accordion:cancelled'))),
      (this.animation = this.el.animate(
        { height: [i, e] },
        { duration: this.#i.matches ? 0 : 300, easing: 'ease-in-out' }
      )),
      (this.animation.onfinish = () => {
        this.onAnimationFinish(!1),
          this.el.dispatchEvent(new CustomEvent('on:accordion:closed'));
      }),
      (this.animation.oncancel = () => {
        (this.isClosing = !1), this.el.classList.remove('is-closing');
      });
  }
  open() {
    (this.el.style.overflow = 'hidden'),
      (this.el.style.height = `${this.el.offsetHeight + 40}px`),
      (this.el.open = !0),
      window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.el.dispatchEvent(new CustomEvent('on:accordion:opening')),
      (this.isExpanding = !0),
      this.el.classList.add('is-opening');
    const i = `${this.el.offsetHeight + 40}px`,
      e = `${this.summary.offsetHeight + this.content.offsetHeight + 40}px`;
    this.animation &&
      (this.animation.cancel(),
      this.el.dispatchEvent(new CustomEvent('on:accordion:cancelled'))),
      (this.animation = this.el.animate(
        { height: [i, e] },
        { duration: this.#i.matches ? 0 : 300, easing: 'ease-in-out' }
      )),
      (this.animation.onfinish = () => {
        this.onAnimationFinish(!0),
          this.el.dispatchEvent(new CustomEvent('on:accordion:opened'));
      }),
      (this.animation.oncancel = () => {
        (this.isExpanding = !1), this.el.classList.remove('is-opening');
      });
  }
  onAnimationFinish(i) {
    (this.el.open = i),
      (this.animation = null),
      (this.isClosing = !1),
      this.el.classList.remove('is-closing'),
      (this.isExpanding = !1),
      this.el.classList.remove('is-opening'),
      (this.el.style.height = ''),
      (this.el.style.overflow = '');
  }
}
export { Accordion };
class AccordionGroup extends HTMLElement {
  #e;
  #t;
  #s;
  #n;
  constructor() {
    super(), (this.#s = this.#o.bind(this)), (this.#t = this.#a.bind(this));
  }
  connectedCallback() {
    if (
      ((this.#n = this.hasAttribute('single-open')),
      (this.#e = this.hasAttribute('always-open')),
      (this.triggers = this.querySelectorAll('summary')),
      (this.details = this.querySelectorAll('details')),
      (this.accordions = {}),
      0 !== this.details.length)
    ) {
      if (
        (this.details.forEach((i) => {
          this.accordions[i.id] = new Accordion(i);
        }),
        this.#n)
      ) {
        const i = Array.from(this.querySelectorAll('details[open]'));
        i.length > 0
          ? i.forEach((i, e) => {
              e > 0 && this.close(i.id);
            })
          : this.open(this.details[0].id),
          this.details.forEach((i) => {
            i.addEventListener('on:accordion:opening', this.#s);
          });
      }
      if (this.#e) {
        let i = this.querySelector('details[open]');
        i ||
          (this.details.length > 0 &&
            (this.open(this.details[0].id), ([i] = this.details))),
          i && i.setAttribute('non-dismissible', ''),
          this.details.forEach((i) => {
            i.addEventListener('on:accordion:opening', this.#t);
          });
      }
      window.addEventListener('DOMContentLoaded', () => {
        document
          .querySelectorAll(
            Array.from(this.details)
              .map((i) => `a[href="#${i.id}"]`)
              .toString()
          )
          .forEach((i) => {
            i.addEventListener('click', (e) => {
              e.preventDefault(), this.open(i.getAttribute('href').slice(1));
              const t = document.querySelector(i.getAttribute('href'));
              if (t) {
                let i = 24;
                const e = document.querySelector('.js-header');
                e &&
                  e.classList.contains('js-header-sticky') &&
                  (i += e.offsetHeight);
                const s = document.querySelector('.js-section__announcement');
                s && (i += s.offsetHeight),
                  window.scrollTo({ top: t.offsetTop + i, behavior: 'smooth' });
              }
            });
          });
      });
    }
  }
  disconnectedCallback() {
    (this.#n || this.#e) &&
      this.details.forEach((i) => {
        this.#n && i.removeEventListener('on:accordion:opening', this.#s),
          this.#e && i.removeEventListener('on:accordion:opening', this.#t);
      });
  }
  open(i) {
    this.accordions[i] && this.accordions[i].open();
  }
  close(i) {
    this.accordions[i] && this.accordions[i].shrink();
  }
  #o(i) {
    const { id: e } = i.target.closest('details'),
      t = Array.from(this.querySelectorAll('details[open]'));
    Array.from(t)
      .filter((i) => i.id !== e)
      .forEach((i) => {
        this.close(i.id);
      });
  }
  #a(i) {
    Array.from(this.querySelectorAll('details[non-dismissible]')).forEach(
      (i) => {
        i.removeAttribute('non-dismissible');
      }
    ),
      i.target.setAttribute('non-dismissible', '');
  }
}
customElements.define('accordion-group', AccordionGroup);
//# sourceMappingURL=accordion-group.js.map
